{
    "name": "idle",
    "duration": 1.33333337,
    "keyframes": {
        "/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "fruit/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "fruit/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "fruit/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "fruit/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "/m_LocalPosition.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "fruit/m_LocalPosition.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "fruit/m_LocalPosition.y": [
            0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5
        ],
        "fruit/m_LocalPosition.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalScale.x": [
            1.0, 1.00146961, 1.004401, 1.0082221, 1.01236117, 1.01624644, 1.01930618,
            1.02096844, 1.02066147, 1.01781344, 1.0125612, 1.00727832, 1.00293136,
            1.00033534, 1.0
        ],
        "/m_LocalScale.y": [
            1.0, 1.00146961, 1.004401, 1.0082221, 1.01236117, 1.01624644, 1.01930618,
            1.02096844, 1.02066147, 1.01781344, 1.0125612, 1.00727832, 1.00293136,
            1.00033534, 1.0
        ],
        "/m_LocalScale.z": [
            1.0, 1.00146961, 1.004401, 1.0082221, 1.01236117, 1.01624644, 1.01930618,
            1.02096844, 1.02066147, 1.01781344, 1.0125612, 1.00727832, 1.00293136,
            1.00033534, 1.0
        ]
    },
    "wrapMode": 1,
    "guid": "b7554e7c635ba4d17ba68e6e331e3abc",
    "assetPath": "Assets/Oddities/fruit@idle.fbx"
}
